import {condition, request} from "../../../../../res/rest/restRequest";
import {api} from "../../../../../res/rest/api";
import solrMultiBuyRequest from "../promotion/solrMultiBuyRequest";

const promotionRequest = (bPartnerID) => {

    const builder = {};

    const req = request.model(api.MODEL.PRICE_PROMOTION)
        .select("c_campaign_ID", "Name", "M_Product_ID", "startDate", "endDate")
        .filter(condition.eq("c_bpartner_ID", bPartnerID))
        .orderBy("startDate")
    ;

    const getMultiBuyPromotions = async (session) => {
        const { promotions } = await solrMultiBuyRequest().sendRequest(session);
        const applicablePromotions = promotions.filter(promo => promo.isActive(session.priceListID));
        return applicablePromotions.flatMap(promo => promo.productIDs.map(pid => (
            {
                c_campaign_ID: Number(promo.id.substr(11)),
                Name: promo.name,
                startDate: new Date(),
                endDate: new Date(),
                id: pid
            }
        )));
    }

    builder.sendRequest = async (session) => {
        const results = await api.getAllRequestPages(req, session);
        const multiBuys = await getMultiBuyPromotions(session);

        const items = [...multiBuys, ...results];

        return { items }
    }

    return builder;
}

export default promotionRequest;
